import { isAxiosError } from 'axios'
import {
  CAPTCHA_RESPONSE_CODES,
  isCaptchaResponseCode,
  isCaptchaThrottled,
} from 'entities/Auth/lib/captchaErrors'

/**
 * SWR-24499 / SO-22562 M3: the form must answer the same way whether or not the address has an
 * account, so anything the backend says about the address resolves to `neutral` and the
 * confirmation screen. Captcha refusals are the exception: they fire the same either way, and
 * the request never reached the reset logic, so a confirmation screen would promise an email
 * that is not coming.
 */
export type IForgotOutcome = 'neutral' | 'error'

const SERVER_ERROR_STATUS = 500

const isCaptchaRefusal = (e: unknown) =>
  isCaptchaResponseCode(e, CAPTCHA_RESPONSE_CODES.tokenInvalid) ||
  isCaptchaResponseCode(e, CAPTCHA_RESPONSE_CODES.unavailable) ||
  isCaptchaThrottled(e)

export const resolveForgotOutcome = (e: unknown): IForgotOutcome => {
  if (!isAxiosError(e) || !e.response) return 'error'

  if (e.response.status >= SERVER_ERROR_STATUS) return 'error'

  if (e.errors?.getError('email')) return 'neutral'

  if (isCaptchaRefusal(e)) return 'error'

  return 'neutral'
}
